/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: authenticationCodesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteAuthenticationRule } from './api';

/**
 * Shared helpers for Authentication Codes module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate an Authentication Rule in the form.
 * Pattern: /pbx/incoming-tools/auth-codes/new?duplicate={id}
 */
export const getAuthenticationRuleDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/auth-codes/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Authentication Rule id.
 */
export const navigateToAuthenticationRuleDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getAuthenticationRuleDuplicateUrl(id));
};

/**
 * Low-level API helper to delete an Authentication Rule by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteAuthenticationRule from './api' instead
 */
export const deleteAuthenticationRuleById = async (id: string | number): Promise<void> => {
  await deleteAuthenticationRule(id);
};

